import { Modal, ModalId } from "../../../../../features/ui"
import { AdjustmentNote } from "../../../../administration"
import { useActions } from "./actions"

type Props = {
    adjustmentNote?: AdjustmentNote
    authorizedInvoiceCount?: number
    isSale?: boolean
    onRefresh?: () => Promise<void>
}

export const GenerateCreditNoteModal = (props: Props) => {
    const { adjustmentNote, authorizedInvoiceCount, isSale = false, onRefresh } = props

    const { generateCreditNote } = useActions(onRefresh)

    const onSubmit = () => adjustmentNote && generateCreditNote(adjustmentNote)

    const invoiceCountSuffix = authorizedInvoiceCount ? ` (${authorizedInvoiceCount})` : ''

    return (
        <Modal
            modalId={ModalId.GENERATE_CREDIT_NOTE}
            title="Generar Nota de Crédito"
            submitLabel="Confirmar"
            onSubmit={onSubmit}
        >
            <>{`¿Confirmás la generación de la nota de crédito? Se asociará a todas las facturas autorizadas ${isSale ? 'de la venta' : 'del acopio'}${invoiceCountSuffix}. Se emitirá un documento fiscal a partir de la nota de ajuste seleccionada.`}</>
        </Modal>
    )
}
